(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bw-featured-paddles"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-weekly-paddles]';
  const weekKey = () => {
    const parts = new Intl.DateTimeFormat('en-US', {timeZone: 'America/Chicago', year: 'numeric', month: 'numeric', day: 'numeric'}).formatToParts(new Date());
    const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
    const date = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day)));
    date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
    const year = date.getUTCFullYear();
    const week = Math.ceil((((date - new Date(Date.UTC(year, 0, 1))) / 86400000) + 1) / 7);
    return String(year) + String(week).padStart(2, '0');
  };
  const initialize = root => {
    if (root.dataset.rotationReady) return;
    root.dataset.rotationReady = 'true';
    let completedWeek = '';
    let busy = false;
    const refresh = async () => {
      if (!root.isConnected || busy) return;
      const week = weekKey();
      if (completedWeek === week) return;
      busy = true;
      try {
        const readPage = async page => {
          const url = new URL(window.location.href);
          url.searchParams.set('section_id', root.dataset.sectionId);
          url.searchParams.set(root.dataset.pageParam || 'page', String(page));
          url.searchParams.set('bw_paddle_week', week);
          const response = await fetch(url, {credentials: 'same-origin'});
          if (!response.ok) throw new Error('Paddle section unavailable');
          const document = new DOMParser().parseFromString(await response.text(), 'text/html');
          const section = document.querySelector(selector);
          if (!section || section.dataset.week !== week) throw new Error('Paddle rotation is awaiting a fresh render');
          return section;
        };
        const first = root.dataset.week === week && Number(root.dataset.page) === 1 ? root : await readPage(1);
        const pages = Number(first.dataset.pages) || 1;
        const sections = [first];
        for (let page = 2; page <= pages; page++) sections.push(await readPage(page));
        const unique = new Map();
        sections.forEach(section => section.querySelectorAll('.bw-paddle__card').forEach(card => unique.set(card.dataset.productId, card)));
        const cards = [...unique.values()].sort((a, b) => Number(a.dataset.weeklyRank) - Number(b.dataset.weeklyRank) || a.dataset.productId.localeCompare(b.dataset.productId)).slice(0, Number(root.dataset.limit) || 4);
        const grid = root.querySelector('.bw-paddle__grid');
        if (grid && cards.length) {
          grid.replaceChildren(...cards.map(card => card.cloneNode(true)));
          root.hidden = false;
        } else if (!cards.length) {
          root.hidden = true;
        }
        root.dataset.week = week;
        root.dataset.page = '1';
        root.dataset.pages = String(pages);
        completedWeek = week;
      } catch (error) {
        console.warn('Weekly paddle rotation:', error.message);
      } finally {
        busy = false;
      }
    };
    refresh();
    const timer = setInterval(() => {
      if (!root.isConnected) { clearInterval(timer); return; }
      refresh();
    }, 60000);
  };
  document.querySelectorAll(selector).forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll(selector).forEach(initialize));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bw-new-arrivals-slider"] && !Shopify.designMode) return;
  try {
    
function setupArrivalsControls(root){
  root.querySelectorAll('.bw-new-arrivals').forEach(section=>{
    if(section.dataset.controlsReady)return;
    const grid=section.querySelector('.bw-new-arrivals__grid');
    const previous=section.querySelector('[data-arrivals-prev]');
    const next=section.querySelector('[data-arrivals-next]');
    if(!grid||!previous||!next)return;
    section.dataset.controlsReady='true';
    const update=()=>{previous.disabled=grid.scrollLeft<=1;next.disabled=grid.scrollLeft+grid.clientWidth>=grid.scrollWidth-2;};
    const move=direction=>{const card=grid.querySelector('.bw-new-arrivals__card');const distance=card.getBoundingClientRect().width+parseFloat(getComputedStyle(grid).columnGap||0);grid.scrollBy({left:direction*distance,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
    previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
    grid.addEventListener('scroll',update,{passive:true});
    new ResizeObserver(update).observe(grid);update();
  });
}
setupArrivalsControls(document);
document.addEventListener('shopify:section:load',()=>setupArrivalsControls(document));

  } catch(e) { console.error(e); }
})();
})();
